<template>
	<div class='container flex-center'>
		<div v-if="loading">
			<div>
				<div class='container-loader'>
					{{ $t("components.paypal_checkout.process") }}
				</div>
			</div>
			<loading-spin :height='100'></loading-spin>
		</div>
		<div v-else>
			<div class="text-center">{{ message }}. <router-link to="verify-page">Torna indietro</router-link></div>
		</div>
	</div>
</template>

<script>
import { getParameterByName } from '../../assets/js/main'
import { EdenredApi } from '../../api/EdenredApi'
import { orderStore } from '../../store/orderStore'
export default {

	data () {
		return {
			loading: true,
			token: null,
			authorizationCode: null,
			orderStore: orderStore.state
		}
	},

	computed: {
		user () {
			return this.$root.user
		}
	},
	methods: {
		getCode () {
			this.authorizationCode = getParameterByName('code')
			return Promise.resolve()
		},

		addTicket (vars) {
			if (!vars || !vars.code) return
			var token = this.user.order.token
			var em = new EdenredApi()
			return em.estimate(token, vars.code)

			.then(response => {
			})
			.catch(response => {
				this.loading = false;
				this.message = "Si è verificato un errore"
			})
		}
	},
	mounted () {
		this.loading = true
		return this.getCode()

		.then(response => {
			return this.addTicket({ code: this.authorizationCode })
		})

		.then(response => {
			this.loading = false
			
			if (this.user.subscription.status === 'pending') {
				this.$router.push({ name: 'flow-new', query: {edenred:"open"} });
				return;
			}

			this.$router.push({ name: 'verify-page', query: {edenred:"open"} })
		})
	}
}

</script>

<style scoped>
	.error {
		margin: 10px 0;
	}
	.content {
		text-align: center;
	}
</style>
